export interface TitleDetail {
  title?: string;
  subtitle?: string;
}

export const TitleMapper: Record<string, TitleDetail> = {
  GAD7: {
    title: "GAD-7 (for Anxiety) - Please select one to the following",
    subtitle:
      "The Generalized Anxiety Disorder 7-item (GAD-7) is a easy to perform initial screening tool for generalized anxiety disorder.",
  },
  PHQ9: {
    title: "PHQ-9 (for Depression) - Please select one to the following",
    subtitle:
      "The PHQ-9 is a multipurpose instrument for screening, diagnosing,monitoring and measuring the severity of depression.",
  },
  MDQ: {
    title: "Mood Disorder Questionnaire (MDQ)",
    subtitle:
      "Employing the Mood Disorder Questionnaire (MDQ) to screen for potential mood disorders.",
  },
  CAGE: {
    title: "CAGE (for Alcohol) - Please answer Yes or No for the following",
    subtitle:
      "CAGE is a 4-item questionnaire that can indicate potential problems with alcohol use.",
  },
  SUBSTANCE_ABUSE: {
    title: "DAST-10 (for Substance Abuse)",
    subtitle:
      "The DAST-10 is a 10-item self-report tool used to screen for drug abuse and dependence within the past 12 months.",
  },
  OBESITY_SCREENING: {
    title: "Obesity Screening",
    subtitle:
      "Weight history, eating habits and barriers to weight loss, with the provider's counseling details.",
  },
  TOBACCO_SCREENING: {
    title: "Smoking Screening",
    subtitle:
      "Tobacco use, cessation counseling, treatment plan, billing time and attestation.",
  },
  DIABETES_ASSESSMENT: { title: "Diabetic Screening" },
  ANNUAL_WELLNESS: { title: "Medicare Annual Wellness Visit" },
};

// const DrawerTitleMapper: Record<string, string> = {
//   GAD7: "GAD7",
//   PHQ9: "PHQ9",
//   SUBSTANCE_ABUSE: "Substance Abuse",
//   CAGE: "Cage",
//   MDQ: "MDQ",
// };

export const FREE_TEXT_FORM = {
  notesPlaceholder: "Specify Details...",
  numberMax: 999,
  borderColor: "#E0E0E0",
  inputWidth: 180,
  multilineRows: 3,
  maxRows: 6,
} as const;

export const HOME_HEALTH_SCREENER_TYPES = {
  annualWellness: "ANNUAL_WELLNESS",
  diabetic: "DIABETES_ASSESSMENT",
  smoking: "TOBACCO_SCREENING",
  obesity: "OBESITY_SCREENING",
} as const;

export const SCREENING_SAVE_LABEL = "Save";
// Inline screeners scroll within this height so the Save button stays in view.
export const SCREENING_FORM_MAX_HEIGHT = "60vh";
// Saved answers are paged before they are matched to questions, so the page must hold the longest screener (Annual Wellness has ~75).
export const SCREENING_PREFILL_PAGE_SIZE = 200;
export const SCREENING_EMPTY_ANSWER_MESSAGE =
  "Please answer at least one question.";
export const SCREENING_MISSING_CONTEXT_MESSAGE =
  "Open this note from an appointment to save.";
export const SCREENING_NO_QUESTIONS_MESSAGE =
  "No questions are configured for this screening yet.";
export const SCREENING_PREFILL_QUERY_KEY = "encounter-all=screening-list";
export const SCREENING_PREVIEW_QUERY_KEY = "encounter-all=screening-preview";

export const YES = "Yes";
export const YES_NO = [YES, "No"];
